import { User } from '@socrates/common';

export interface OrgPublicInfo {
	id: string;
	name: string;
	joinMode: 'OPEN' | 'REVIEW';
	isPaymentRequired: boolean;
	chargeAmount: number | null;
	isMonthlyCharge: boolean;
}

export interface SignupPayload {
	orgId: string;
	email: string;
	password: string;
	firstName: string;
	lastName: string;
	stripePaymentMethodId?: string;
	billingName?: string;
	billingZip?: string;
	tosVersion: string;
	timezone?: string;
	notifyFloorEvents: boolean;
	notifyObjections: boolean;
	notifyDecisions: boolean;
	inviteToken?: string;
}

export interface SignupOutcome {
	joinMode: 'OPEN' | 'REVIEW';
	message: string;
}

export interface ProfilePayload {
	firstName: string;
	lastName: string;
	timezone?: string;
	notifyFloorEvents: boolean;
	notifyObjections: boolean;
	notifyDecisions: boolean;
	notifyDiscussion: boolean;
}

export interface ProfileData extends ProfilePayload {
	email: string;
}

export abstract class IUserRepo {
	abstract firstLoginResetPassword(username: string, newPassword: string): Promise<User>;
	abstract logout(): void;
	abstract loginUser(userCredentials: any): Promise<User>;
	abstract passwordResetConfirm(username: string, newPassword: string, passwordCode: string): Promise<User>;
	abstract requestPasswordReset(username: string): Promise<boolean>;
	abstract updateOwnUser(user: User): Promise<User>;
	abstract updateOwnPassword(password: string): Promise<boolean>;
	abstract userFromSession(): User;
	abstract validateSession(): Promise<User>;
	abstract listPublicOrgs(): Promise<OrgPublicInfo[]>;
	abstract signup(payload: SignupPayload): Promise<SignupOutcome>;
	abstract resolveInvite(token: string): Promise<{ orgId: string; orgName: string }>;
	abstract getOwnProfile(): Promise<ProfileData>;
	abstract updateProfile(payload: ProfilePayload): Promise<void>;
	abstract getMyAccount(): Promise<{ trustLevel: number; accountState: string }>;
}
